import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';

export interface SelectOption {
    label: string;
    value: string | number;
}

export interface SelectGroupProps {
    id?: string;
    label?: string;
    placeholder?: string;
    options: SelectOption[];
    value?: string | number;
    required?: boolean;
    error?: boolean;
    readonly?: boolean;
    errorMessage?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectGroup',
  props: {
    id: null,
    label: null,
    placeholder: { default: 'Selecciona una opción' },
    options: null,
    value: null,
    required: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    readonly: { type: Boolean },
    errorMessage: { default: 'Campo inválido' }
  },
  emits: ["update", "change"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update', value: string | number): void
    (e: 'change', value: string | number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id?: string, label?: string, placeholder: string, options: SelectOption[], value?: string | number, required: boolean, error: boolean, readonly?: boolean, errorMessage: string };





const isOpen = ref(false);
const internalSelected = ref<string | number | undefined>(props.value);

watch(() => props.value, (newValue) => {
    internalSelected.value = newValue;
});

const displayValue = computed(() => {
    if (internalSelected.value === undefined) return null;
    const selected = props.options.find(opt => opt.value === internalSelected.value);
    return selected ? selected.label : null;
});

const hasError = computed(() => props.error);

const ariaLabel = computed(() => {
    return displayValue.value || props.placeholder || 'Seleccionar opción';
});

const toggleDropdown = () => {
    if (isOpen.value) {
        closeDropdown();
    } else {
        openDropdown();
    }
};

const openDropdown = () => {
    isOpen.value = true;
};

const closeDropdown = () => {
    isOpen.value = false;
};

const selectOption = (option: SelectOption) => {
    internalSelected.value = option.value;
    emit('update', option.value);
    emit('change', option.value);
    closeDropdown();
};

if (props.value !== undefined) {
    internalSelected.value = props.value;
}

return { __sfc: true,props, emit, isOpen, internalSelected, displayValue, hasError, ariaLabel, toggleDropdown, openDropdown, closeDropdown, selectOption }
}

})